import { useState } from "react";
import { Database } from "lucide-react";
import ManpowerMaster from "@/pages/manpower/ManpowerMaster";
import ManpowerProjects from "@/pages/manpower/ManpowerProjects";
import ManpowerAttendance from "@/pages/manpower/ManpowerAttendance";
import { DailyWages, WorkPackages, PaymentHistory } from "@/pages/manpower/ManpowerPayments";

export default function ManpowerPage({ toast, me, masterOnly = false, onGoMaster }) {
  const perms = me.permissions || [];
  const can = (p) => perms.includes(p);
  const canManage = can("manpower") && ["super_admin", "owner", "admin", "pm", "supervisor"].includes(me.role);
  const canPay = can("manpower-payment");
  const canPermanent = can("data-management") || me.project_scope === "all";
  const tabs = masterOnly ? [{ id: "master", label: "Master Tukang" }] : [
    (can("manpower") || can("manpower-attendance")) && { id: "projects", label: "Per Project" },
    can("manpower-attendance") && { id: "attendance", label: "Absensi" },
    (can("manpower") || can("manpower-payment")) && { id: "wages", label: "Upah Harian" },
    (can("manpower") || can("manpower-payment")) && { id: "borongan", label: "Borongan" },
    (can("manpower") || can("manpower-payment")) && { id: "payments", label: "Histori Pembayaran" },
  ].filter(Boolean);
  const [tab, setTab] = useState(masterOnly ? "master" : can("manpower-attendance") && !can("manpower") ? "attendance" : tabs[0]?.id);
  if (masterOnly) return <div data-testid="master-manpower-page"><ManpowerMaster toast={toast} canManage={canManage} canPermanent={canPermanent} /></div>;
  return (
    <div data-testid="manpower-page">
      <div className="filter-tabs" style={{ marginBottom: 18, alignItems: "center" }}>
        {tabs.map(t => <button key={t.id} data-testid={`mp-tab-${t.id}`} className={tab === t.id ? "selected" : ""} onClick={() => setTab(t.id)}>{t.label}</button>)}
        {can("manpower") && onGoMaster && <button className="ghost-btn" style={{ marginLeft: "auto" }} data-testid="mp-go-master" onClick={onGoMaster}><Database size={13} /> Master Tukang (Master Data)</button>}
      </div>
      {tab === "master" && <ManpowerMaster toast={toast} canManage={canManage} canPermanent={canPermanent} />}
      {tab === "projects" && <ManpowerProjects toast={toast} canManage={canManage} />}
      {tab === "attendance" && <ManpowerAttendance toast={toast} me={me} />}
      {tab === "wages" && <DailyWages toast={toast} canPay={canPay} />}
      {tab === "borongan" && <WorkPackages toast={toast} canManage={canManage} canPay={canPay} />}
      {tab === "payments" && <PaymentHistory />}
    </div>
  );
}
